import React from "react";
import { useDispatch } from "react-redux";

import List from "@mui/material/List";

import MoreOptionsButton from "../../../../modules/common/components/buttons/moreOptionsButton";
import { Divider, Typography } from "@mui/material";
import MoreOptionsItem from "modules/common/components/moreOptionsItem";
import { TopicDetails } from "modules/topics/models";
import { TopicDeletionHandler } from "modules/topics/utils/topicDeletionHandler";
import { TopicReportHandler } from "modules/topics/utils/topicReportHandler";
import { ReportTypes } from "modules/reports/models";
import { editTopicState } from "modules/topics/reducer";

const MoreOptions: React.FunctionComponent<ComponentProps> = props => {
    const dispatch = useDispatch();
    
    const onHandleDelete = () => {
        const topic = {
            id: props.topic.id,
            name: props.topic.name
        };
        const topics = {
            topics: [topic]
        };

        props.closeDialog();
        new TopicDeletionHandler(topics, dispatch).onHandleDelete();
    };

    const handleDownload = async () => {
        await new TopicReportHandler(props.topic.name, props.topic.id).requestReport(ReportTypes.TopicAllReport);
        props.onReport();
    };

    const handleStateUpdate = (disable: boolean) => 
        dispatch(editTopicState({topics: [props.topic.id], disable}));

    const deleteTopicText = () : JSX.Element =>
        <Typography className="red-text">
            Delete
        </Typography>;

    return (
        <div style={{ paddingRight: "20px" }}>
            <MoreOptionsButton text="Actions">
                <List disablePadding>
                    <MoreOptionsItem
                        text="Edit"
                        onClick={
                            () => {
                                props.onEdit();
                                props.closeDialog();
                            }}
                    />
                    <MoreOptionsItem
                        text="Move topic"
                        onClick={() => {
                            props.onMove();
                            props.closeDialog();
                        }}
                    />
                    <MoreOptionsItem
                        text="Download all reports"
                        onClick={handleDownload}
                    />

                    <MoreOptionsItem
                        text={props.topic.disabled ? "Enable" : "Disable"}
                        onClick={() => handleStateUpdate(!props.topic.disabled)}
                    />

                    <Divider light />
                    <MoreOptionsItem
                        text={deleteTopicText()}
                        onClick={onHandleDelete}
                    />
                </List>
            </MoreOptionsButton>
        </div>
    );
};

interface ComponentProps {
    topic: TopicDetails;
    onReport: () => void;
    closeDialog: () => void;
    onEdit: () => void;
    onMove: () => void;
}

export default MoreOptions;